/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-11.
 */
import React, { Component } from 'react';
import { Dialog, FlatButton } from 'material-ui';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { v1 } from 'node-uuid';
import { DropDownSearch, Select, DynamicTableV2 } from '../../components/data-containers';
import { Fieldset } from '../../components/layout';
import { extractProperty } from '../../common/helpers';
import Honorarios from './honorarios';
import HonorariosTypeFLAT from './honorariosTypeFLAT';

import {
    customerTabularPriceses as customerTabularPricesesService
} from '../../services';
import Checkbox from 'material-ui/Checkbox';

const columns = [
    {
        prop: 'concepto',
        title: 'Concepto',
        type: 'remote_autocomplete',
        colClass: 'col-md-3 col-xs-12',
        showAsLabel: (row) => row.useLabel,
        customLabel: (row) => row.concepto.concept
    },
    {
        prop: 'precio',
        title: 'Precio',
        type: 'text',
        colClass: 'col-md-4 col-xs-12'
    },
    {
        prop: 'aplicables',
        title: 'Aplicables',
        type: 'label',
        colClass: 'col-md-4 col-xs-12',
        //Replace this for the applicable
        calculateValue: (row) => row.concepto.applicable
    }
];

const state = {
    id: '',
    aduana: 0,
    moneda: 'MXN',
    importacion: { porcentaje: '', contenedor: '', caja: '' },
    exportacion: { porcentaje: '', contenedor: '', caja: '' },
    importacionFlat: { tarifa: '' },
    exportacionFlat: { tarifa: '' },
    gastos: [{ concepto: '', precio: '', aplicables: '', useLabel: false, id: '' }],
    gastosOpcionales: [{ concepto: '', precio: '', aplicables: '', useLabel: false, id: '' }],
    DisableSave: true,
    DisableButton: true,
    IsSaving: false,
    useLabel: false,
    checkedTypeFLAT: false,
}

var auxOriExpenses = [];
var auxOriOpcExpenses = [];

class TabuladorCustomForm extends Component {
    /**
     * Datos de tablas dinàmicas
     * gastos: Gastos aplicables a la Importacion, Exportacion y Operaciones Especiales
     * gastosOpcionales: Gastos que pueden ser aplicables a la Importacion y Exportacion
     */
    constructor() {
        super();
        this.id = v1();
        this.state = {
            ...state
        };
    }
    searchFirstSection(nameKey, nameKey2) {
        customerTabularPricesesService.getCustomTabularPrices({
            customsHouseId: nameKey,
            customerId: nameKey2,
            projection: 'tabularForForm'
        }).then(data => {
            this.setState({ DisableSave: false });
            if (!data.length > 0) {
                return;
            }
            this.setState({ IsSaving: true })
            this.setState({ tabulador: data[0] })
            this.searchSecondsection(data[0], data[0].id);
        })
    }

    searchSecondsection(myArray, customerTabularId, ) {
        customerTabularPricesesService.getExpensesTabularPrices({
            tabularId: customerTabularId,
            projection: 'expensesForForm',
        }).then(expensesTabularPriceses => {
            this.fillFields(myArray, expensesTabularPriceses);
        });
    }

    fillFields(ArraytoFill, arraySecond) {
        var arrayGastos = [];
        var arrayGastosOpcionales = [];

        this.setState({ id: ArraytoFill.id });
        this.setState({ moneda: ArraytoFill.currency });
        if (ArraytoFill.tabularType === "FLAT") {
            this.setState({ checkedTypeFLAT: true });
            this.setState({ importacionFlat: { tarifa: ArraytoFill.flatImportFee } });
            this.setState({ exportacionFlat: { tarifa: ArraytoFill.flatExportFee } });

        } else {
            this.setState({ checkedTypeFLAT: false });
            this.setState({ importacion: { porcentaje: ArraytoFill.importFee, contenedor: ArraytoFill.complementaryImportCharge, caja: ArraytoFill.minimumImportFee } });
            this.setState({ exportacion: { porcentaje: ArraytoFill.exportFee, contenedor: ArraytoFill.complementaryExportCharge, caja: ArraytoFill.minimumExportFee } });
        }

        for (var i = 0; i < arraySecond.length; i++) {
            if (arraySecond[i].expenseType === "Gastos aplicables") {
                arrayGastos.push({ concepto: arraySecond[i].invoiceItem, precio: arraySecond[i].priceValue, applicables: '', useLabel: true, id: arraySecond[i].id });
            } else {
                arrayGastosOpcionales.push({ concepto: arraySecond[i].invoiceItem, precio: arraySecond[i].priceValue, applicables: '', useLabel: true, id: arraySecond[i].id });
            }
        }

        if (arrayGastos.length == 0) {
            arrayGastos.push({ concepto: '', precio: '', applicables: '', useLabel: '', id: '' });
        }
        if (arrayGastosOpcionales.length == 0) {
            arrayGastosOpcionales.push({ concepto: '', precio: '', applicables: '', useLabel: '', id: '' });
        }

        this.setState({ gastos: arrayGastos });
        this.setState({ gastosOpcionales: arrayGastosOpcionales });

        auxOriExpenses = arrayGastos;
        auxOriOpcExpenses = arrayGastosOpcionales;

        this.setState({ DisableButton: false });
    }

    compareValue(array, value) {
        var a = array.findIndex(x => x.id == value);
        return a;
    }

    updateCheck() {
        this.setState((oldState) => {
            return {
                checkedTypeFLAT: !oldState.checkedTypeFLAT,
            };
        });
    }

    render() {
        const { aduana, moneda, gastos, gastosOpcionales, DisableSave } = this.state;
        const {
            onSave,
            onCancel,
            customsHouses = [],
            customerTabularPriceses = {},
            tabuladorState = {},
            monedas = [
                { id: 'MXN', name: 'Pesos (MXN)' },
                { id: 'USD', name: 'Dolares (USD)' }
            ],
            selects = {
                concepto: [{ id: 1, name: 'Concepto 1' }, { id: 2, name: 'Concepto 2' }]
            },
            expensesTabularPriceses = [],
            Actions,
            allowCreateTabular
        } = this.props;

        return (
            <Dialog {...this.props}>
                <div className="row margin-top-2 margin-bottom-2">
                    <div className="col-md-6">
                        <DropDownSearch
                            id={`${this.id}_customHouse`}
                            label="Aduana"
                            fullWidth
                            dataSource={extractProperty(customsHouses, 'name')}
                            value={aduana}
                            onNewRequest={(request, index) => {
                                this.setState({ ...state }); //this is for clear all the form when you select another customsHouse
                                this.setState({ aduana: customsHouses[index].id });
                                this.searchFirstSection(this.state.aduana, this.props.tabuladorState.customer.id);
                            }}
                        />
                    </div>
                    <div className="col-md-6">
                        <Select
                            label="Moneda"
                            value={moneda}
                            notify={(value) => this.setState({ moneda: value })}
                            options={monedas}
                        />
                    </div>
                    <div className="col-md-6">
                        <Checkbox
                            label="Tabulador tipo FLAT"
                            checked={this.state.checkedTypeFLAT}
                            onCheck={this.updateCheck.bind(this)}
                            labelStyle={{ color: '#b9b7b7' }}
                        />
                    </div>
                </div>

                <Fieldset
                    contentClass="col-md-6 pl0"
                    legend="Importación"
                >
                    {
                        !this.state.checkedTypeFLAT && <Honorarios
                            notify={(value) => this.setState({ importacion: value })}
                            searchText={this.state.importacion}
                        />
                    }
                    {
                        this.state.checkedTypeFLAT && <HonorariosTypeFLAT
                            notify={(value) => this.setState({ importacionFlat: value })}
                            searchText={this.state.importacionFlat}
                        />
                    }
                </Fieldset>

                <Fieldset
                    contentClass="col-md-6 no-paddings"
                    legend="Exportación"
                >   {
                        !this.state.checkedTypeFLAT && <Honorarios
                            notify={(value) => this.setState({ exportacion: value })}
                            searchText={this.state.exportacion}
                        />
                    }
                    {
                        this.state.checkedTypeFLAT && <HonorariosTypeFLAT
                            notify={(value) => this.setState({ exportacionFlat: value })}
                            searchText={this.state.exportacionFlat}
                        />
                    }
                </Fieldset>

                <Fieldset
                    contentClass="col-md-12 no-paddings margin-top-2 margin-bottom-2"
                    legend="Gastos aplicables a la Importacion, Exportacion y Operaciones Especiales"
                >
                    <DynamicTableV2
                        selects={[]}
                        columns={columns}
                        data={gastos}
                        notify={(value) => this.setState({ gastos: value })}
                        Actions={Actions}
                        validateRow={(row) => {
                            return (
                                row.precio > 0
                            );
                        }}
                    />
                </Fieldset>

                <Fieldset
                    contentClass="margin-top-2"
                    legend="Gastos que pueden ser aplicables a la Importacion y Exportacion"
                >
                    <DynamicTableV2
                        selects={[]}
                        columns={columns}
                        data={gastosOpcionales}
                        Actions={Actions}
                        notify={(value) => this.setState({ gastosOpcionales: value })}
                        validateRow={(row) => {
                            return (
                                row.precio > 0
                            );
                        }}
                    />
                </Fieldset>

                <div className="col-md-12 no-paddings margin-top-2 text-right">
                    <FlatButton
                        label="Cancelar"
                        onClick={() => {
                            onCancel();
                            this.setState({ ...state });
                        }
                        }
                    />
                    {
                        allowCreateTabular &&
                        <FlatButton
                            label="Guardar"
                            primary
                            disabled={this.state.DisableSave}
                            onClick={() => {
                                const gastosClean = this.state.gastos.filter(g => !isEmpty(g.concepto));
                                const gastosOpcionalesClean = this.state.gastosOpcionales.filter(g => !isEmpty(g.concepto));
                                onSave({ ...this.state, gastosOpcionales: gastosOpcionalesClean, gastos: gastosClean });
                                this.setState({ ...state });
                            }}
                        />
                    }
                </div>
            </Dialog >
        );
    }
}

export default TabuladorCustomForm;



// WEBPACK FOOTER //
// ./forms/customTabulador/index.js